// extracted by mini-css-extract-plugin
module.exports = {"grid":"SearchResultsGrid_grid__z2G0D"};